import type { VerticalCoverage } from '../content/insuranceVerticals'
import { Checklist } from './Checklist'

export function VerticalCoverageList({ coverages }: { coverages: VerticalCoverage[] }) {
  return (
    <Checklist
      className="gap-5"
      items={coverages.map((coverage) => (
        <span key={coverage.name} className="flex flex-col gap-1">
          <span className="text-ink font-bold">{coverage.name}</span>
          <span className="text-pretty">{coverage.description}</span>
        </span>
      ))}
    />
  )
}
